export const resizeImage = (file, maxWidth) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (event) => {
      img.src = event.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Calculate the new dimensions maintaining aspect ratio
      const scaleFactor = maxWidth / img.width;
      canvas.width = maxWidth;
      canvas.height = img.height * scaleFactor;

      // Draw the resized image onto the canvas
      console.log('Image Loaded. Drawing to canvas...');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // Get the resized image as a Blob
      canvas.toBlob(
        (blob) => {
          console.log('Blob created', blob);
          resolve(blob);
        },
        'image/jpeg', // Specify format
        0.8 // Set the quality (0 to 1), 0.8 for 80%
      );
    };

    img.onerror = (error) => {
      console.error('Image failed to load', error);
      reject(error);
    };

    reader.onerror = (error) => {
      console.error('FileReader error', error);
      reject(error);
    };

    console.log('Starting to read file...');
    reader.readAsDataURL(file); // Read the file as a Data URL
  });
